import React from 'react';
import NationalIdModal from './NationalIdModal';
import JetModal from './JetModal';
import TooltipModal from './TooltipModal';
import setModal from '../../store/ClaimWebsite/commonActions/modal';
import { ClaimWebsiteStore } from '../../store';
import AnnouncementModal from './AnnouncementModal';
import PaperModal from './PaperModal';

const showNationalIdModal = () => {
  ClaimWebsiteStore.dispatch(setModal({
    isShow: true,
    children: <NationalIdModal />,
    closeButton: true,
    onClose: () => closeModal()
  }));
};

const closeModal = () => {
  ClaimWebsiteStore.dispatch(setModal({
    isShow: false
  }));
};

const closeJetModal = () => {
  ClaimWebsiteStore.dispatch(setModal({
    isShow: false
  }));

  showPaperModal();
};

const showJetModal = () => {
  ClaimWebsiteStore.dispatch(setModal({
    isShow: true,
    children: <JetModal />,
    closeButton: true,
    onClose: () => closeJetModal()
  }));
};

const showPaperModal = () => {
  ClaimWebsiteStore.dispatch(setModal({
    isShow: true,
    children: <PaperModal />,
    closeButton: true,
    onClose: () => closeModal()
  }));
};

const showHospitalModal = () => {
  ClaimWebsiteStore.dispatch(setModal({
    isShow: true,
    children: <TooltipModal name="hospital" />,
    closeButton: true,
    onClose: () => closeModal()
  }));
};

const showAnnouncementModal = () => {
  ClaimWebsiteStore.dispatch(setModal({
    isShow: true,
    children: <AnnouncementModal />,
    closeButton: true,
    onClose: () => closeModal()
  }));
};

const iconShowNationalIdModal = {
  icon: 'data:image/png;base64,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',
  callback: () => showNationalIdModal()
};


const iconShowTooltipHospitalModal = {
  icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMvSURBVHgBnVZdTttAEJ6dBF4qFaMQBISq4QSFE9TcIBKE9o1yAsgJSE5AOAHw2AbUcAJyA+AEuFJDKn6a8NKHBO90Zm1Hxjh2wkgbO+PZ/Xb+R8EYdJcvr2amyebXjwDK8rjU459fbl+15u8bV2lnqKSPj4XNPQVqmwBWIZkclqnNtRvHEwHdL2zamFFH/Fr0WT0+qKmArglUz9tIllxAkfrMfwI5p+8O1hf/NJ1UoO7yl11Num7+EDgaaSf/+7QFCfRQKH9TBPtDQI2VXOd7fSRQGIRAH861z/ZgArpf3qwiqf04sCFQZ+FrcTrj3hgZRTXWogpvoDAYn7MeWCMbCDDIRRKId5HnXfZJia/Hzqervvt8GPWH7H1Y3rAU4S4Dip9XhhoZGwMciU9yt42VKMjD4kZJIcomK/JppPMfl8o34jOtqZLvnNbRRzOqkoJanCYMciAg4jcXYE1MopRqMo+1nLqAGJIgkiei2jYYdwVORoDLkdp8YG00/uTX41y7sRPwu8WSpQdT4lMr7IsXWhXKXfnu9mENOR9s8NRqxd0sk3FbmqiG7uCFtrNOs0eazo0lSBfj9gbfVZbsLAMVBYVteR0nLAfyoxrl31glSyEnKxNqL4lfASFcsVu2FVIROcwsj6ljheNIKsf7d8Y3RTH5XOesGSenhlUEZ7IwIf0tlC+49NjelcFBPVgfZx8Ckoeq0UoTlgDwC2xP8g3/DdZmY0I7IM41z1qgn7JcJB1JJg7DT2lA4q+uVTKRmes1U02N4J1JWjkC1PL5JV47qWBjAITINkDPqoXzbdO0ZFlcp+y0nRJtstLkpNqAHyzSGE1l0EAn8vRrUyJxtF3KSpOLVhsDlG+f1gVZbvBY2DpIOoCUPufyk9i6u0tb+4E2QdcdtgkxG2tk6hY/q7O3P2rwBhIQjsiqOccdrARRiYGAV6uoIu8i6N9qMhC2RgDC7qiEQ/9VK5eBhNmB+VKHDqHojCEgxh0hih1OutwaNHIjDA0dvFogw4nrl5WMJKPJE0kLLwoTZozEcevV0DGSSILjJBfRYmyggLyeRTaZSo8zHlc/cdF0XE54PxcT6T/C+JFUvS5hYwAAAABJRU5ErkJggg==',
  callback: () => showHospitalModal()
};

const iconShowTooltipBlackHospitalModal = {
  icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANMSURBVHgBvVY9VttAEJ5ZuY9vEHGC2I8ij5cC8dKk5AaAITUEKNIES9CCMXWMgROEdHSIJknFzwlQThDTo918o5Uc2ZEtQcG8J6+s3Z1vZ+bbmSF6YeGqC5c3/IZSylNKvzZa1ZPNSg+0Vr+11uFp17+toqcUsLW5u8FslvDaKFkaGcNBv7NzSs8BhEWe4/AJXl35b4gGbPgc4x2RHthVqs6sGwCaZ7brBDiOzQIsjioDrm7trUNpNwEyFCllVnr7fkhTpLXpL0NdOwM2Rn/qd4JuKWAeDNuOjg/8DXqCrG37PixuTwJ18n/gRlcpukhOYkxw3PE/0xPl+kcYzr7zYAh7zPxh9q13df0rjLL52gi6w5cZWK/j++PK5EC1Gq1rw4vQGIFMt4+PdDQeL7jfX93ywWReN5YHM9nc0KUSA5zoRGLW77RnxsGgYBHLZXN9bGoiSVqbwb3ENO9aNURm63e8BUWW4fuhBTNHKjZNWLeAb+f45maeGRchmx3V0oiFcqmx6abEum94To8PdlZyB6lj370chGFlr/s/k1e3gj8yDy80JTmo9CReamVYdNI4ptAgrnGsR6yHgoEm813etRrewxHJ5jOMhDSgsQtfY4zvijaJYgz++HexUBHP28PSoGgvCHiLySXD7CbAZH9TInDhpiKRTFSrJbFzJRS4r+fFK61OZdQrGWv0DEFcBMgDUJKJtBYCVRNroc7cYeplG8SNGBpJbmUTAKw5KW/mdWrWDzImFmJjJIRlct6U4CXxBGjC5L6N7VQBEROdiGU0BNSaQ8dJvoL+tFIFlCoLexmGjCpVIMVTnvoayFCmQtyaunaq2ApiSZUV6GGmQfo5S0ab+6aKJAl5ytYVZa8hoOQ6OYmcaG1793C6KrnMPLWlaG3vCZhrs9e/LmCkHqKWgeo2Lxqj/H7nS0DPEAFjo315R0qbybN4pB6ilkXNufkHqWNgrtece083Py+v6AmCHuiQySR1FO2HVImL/DwXb2qjcVKZWys1R+M9kID19iu0GDkFqP58mW+OsBxJnO502kQpaaKI3qTXKWFtWQ9UoU0cbY4mCqo/+tUzeKI7dRlVlI+omTEaYbjKpTQRE9IVyBU5aIS/VmyEX1z+AomSnF2edXHbAAAAAElFTkSuQmCC',
  callback: () => showHospitalModal()
};

const iconShowJetModal = {
  icon: '',
  callback: () => showJetModal()
};

const iconShowAnnouncementModal = {
  icon: '',
  callback: () => showAnnouncementModal()
};

const iconShowPaperModal = {
  icon: '',
  callback: () => showPaperModal()
};

export {
  showNationalIdModal, iconShowNationalIdModal,
  showJetModal, iconShowJetModal,
  showAnnouncementModal, iconShowAnnouncementModal,
  showPaperModal, iconShowPaperModal,
  showHospitalModal, iconShowTooltipHospitalModal,
  iconShowTooltipBlackHospitalModal
};